<template>
  <div>
    <div v-if="loading">
      <div class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
      </div>
    </div>
    <div v-else class="app-container">
      <div class="banner m-prof-banner">
        <img v-if="viewUser.nfp_info ? viewUser.nfp_info.background_image : viewUser.bg_img_url" :src="viewUser.nfp_info ? viewUser.nfp_info.background_image : viewUser.bg_img_url" alt="bg-image" />
        <img v-else src="https://mycircle-prod.s3.amazonaws.com/default-profile-bg-img1698993539.jpg" alt="background" class="default-profile-bg-img" />
      </div>
      <div class="profile-subnav">
        <div class="dovemed-wrapper w-100">
          <!-- commented left content -->
          <!-- RIGHT CONTENT -->
          <div class="nav-sec p-4">
            <div class="mt-1 profile-tabs">
              <!-- Psoriasis/profile/view/hcp/251/updates -->
              <div
                id="updates"
                :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates` ? 'active-tabs cp' : 'tabs cp'"
                :style="
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates`
                    ? { color: getPrimaryColor(), background: getPrimary50Color() }
                    : { color: '#0F1734' }
                "
                @click="handletab($event)"
              >
                Updates
              </div>
              <div
                id="about"
                :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about` ? 'active-tabs cp' : 'tabs cp'"
                :style="
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about`
                    ? { color: getPrimaryColor(), background: getPrimary50Color() }
                    : { color: '#0F1734' }
                "
                @click="handletab($event)"
              >
                About
              </div>
              <!-- <div
                id="dovedaily"
                :class="
                  this.$route.path ===
                  `/${currentCircle.key_name}/profile/view/${
                    viewUser.role
                  }/${viewUser.id || viewUser.ext_ref_id}/dovedaily`
                    ? 'active-tabs cp'
                    : 'tabs cp'
                "
                :style="
                  this.$route.path ===
                  `/${currentCircle.key_name}/profile/view/${
                    viewUser.role
                  }/${viewUser.id || viewUser.ext_ref_id}/dovedaily`
                    ? {
                        color: getPrimaryColor(),
                        background: getPrimary50Color()
                      }
                    : { color: '#0F1734' }
                "
                @click="handletab($event)"
              >
                DoveDaily
              </div>
              <div
                id="circles"
                :class="
                  this.$route.path.includes('ViewAllCircle') ||
                  this.$route.path.includes('self') ||
                  this.$route.path.includes('hospitals') ||
                  this.$route.path.includes('clinics') ||
                  this.$route.path ===
                  `/${currentCircle.key_name}/profile/view/${
                    viewUser.role
                  }/${viewUser.id || viewUser.ext_ref_id}/circles/nfp` ||
                  this.$route.path.includes('hcp') ||
                  this.$route.path.includes('providers')
                    ? 'active-tabs'
                    : 'tabs'
                "
                :style="
                  this.$route.path.includes('ViewAllCircle') ||
                  this.$route.path.includes('self') ||
                  this.$route.path.includes('hospitals') ||
                  this.$route.path.includes('clinics') ||
                  this.$route.path ===
                  `/${currentCircle.key_name}/profile/view/${
                    viewUser.role
                  }/${viewUser.id || viewUser.ext_ref_id}/circles/nfp`||
                  this.$route.path.includes('hcp') ||
                  this.$route.path.includes('providers')
                    ? {
                        color: getPrimaryColor(),
                        background: getPrimary50Color()
                      }
                    : { color: '#0F1734' }
                "
                @click="handletab($event)"
              >
                Circles
              </div>
              <a-dropdown :trigger="['click']">
                <div
                  :style="
                    this.$route.path.includes('muteduser')||
                    this.$route.path.includes('qa') ||
                    this.$route.path.includes('polls') ||
                    this.$route.path.includes('saved') ||
                    this.$route.path.includes('profilerev') ||
                    this.$route.path.includes('medrev') ||
                    this.$route.path.includes('profilercmnd') ||
                    this.$route.path.includes('treatmentrcmnd')
                      ? {
                          color: getPrimaryColor(),
                          background: getPrimary50Color()
                        }
                      : { color: '#0F1734' }
                  "
                  id="reviews"
                  :class="
                    this.$route.path.includes('muteduser')||
                    this.$route.path.includes('qa') ||
                    this.$route.path.includes('polls') ||
                    this.$route.path.includes('saved') ||
                    this.$route.path.includes('profilerev') ||
                    this.$route.path.includes('medrev') ||
                    this.$route.path.includes('profilercmnd') ||
                    this.$route.path.includes('treatmentrcmnd')
                      ? 'active-tabs'
                      : 'tabs'
                  "
                  @click="() => (displayDots2 = !displayDots2)"
                >
                  <div
                    :style="
                    this.$route.path.includes('muteduser')||
                      this.$route.path.includes('qa') ||
                      this.$route.path.includes('polls') ||
                      this.$route.path.includes('saved') ||
                      this.$route.path.includes('profilerev') ||
                      this.$route.path.includes('medrev') ||
                      this.$route.path.includes('profilercmnd') ||
                      this.$route.path.includes('treatmentrcmnd')
                        ? { color: getPrimaryColor() }
                        : ''
                    "
                    class="tabe"
                  >
                    {{ selectedTab }}
                    <font-awesome-icon
                      size="1x"
                      :icon="
                        displayDots2
                          ? ['far', 'angle-up']
                          : ['far', 'angle-down']
                      "
                      class="mr-2"
                    />
                  </div>
                </div>
                <template #overlay>
                  <a-menu>
                    <a-menu-item id="qa" 
                      @click="() => 
                        {
                              selectedTab='Q&A';
                              $router.push({
                                path: `/${currentCircle.key_name}/profile/view/${
                                  viewUser.role
                                }/${viewUser.id || viewUser.ext_ref_id}/qa`
                              });
                        }" 
                      class="card-item" >
                    Q&A
                    </a-menu-item>
                    <a-menu-item id="polls" 
                      @click="()=>
                      {
                        selectedTab='Polls'
                        $router.push({
                                path: `/${currentCircle.key_name}/profile/view/${
                                  viewUser.role
                                }/${viewUser.id || viewUser.ext_ref_id}/polls`
                              });
                              
                      }
                        " 
                      class="card-item">
                      Polls
                    </a-menu-item>
                    <a-menu-item id="saved" @click="()=>
                    {
                      selectedTab='Saved';
                      $router.push({
                                path: `/${currentCircle.key_name}/profile/view/${
                                  viewUser.role
                                }/${viewUser.id || viewUser.ext_ref_id}/saved`
                              });
                    }"
                      class="card-item" >
                      Saved
                    </a-menu-item>
                    <a-menu-item id="medrev" 
                    @click="()=>
                        {
                          selectedTab='Medication Reviews'
                          $router.push({
                                path: `/${currentCircle.key_name}/profile/view/${
                                  viewUser.role
                                }/${viewUser.id || viewUser.ext_ref_id}/medrev`
                              });
                        }"
                    class="card-item" 
                    >
                      Medication Reviews
                    </a-menu-item>
                    <a-menu-item id="treatmentrcmnd" @click="()=>
                    {
                      selectedTab='Treatment Recommendations'
                      $router.push({
                                path: `/${currentCircle.key_name}/profile/view/${
                                  viewUser.role
                                }/${viewUser.id || viewUser.ext_ref_id}/treatmentrcmnd`
                              });
                    }" class="card-item" >
                      Treatment Recommendations
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown> -->
            </div>
          </div>
        </div>
      </div>

      <!-- mobile view -->
      <div class="circle-card m-prof position-relative">
        <div class="circle-card-content text-center position-relative">
          <div>
            <button class="threedot-menu mob" :style="{ background: '#fff', border: 'none', display: 'flex', 'align-self': 'flex-end' }" @click="() => $refs.drawerShareRef.show()">
              <font-awesome-icon size="1x" :style="{ color: '#94A3B8' }" :icon="['fas', 'ellipsis-v']" />
            </button>
            <a-avatar
              :style="{
                color: ' #ffffff !important',
                'background-color': (viewUser.nfp_info
                ? viewUser.nfp_info.picture
                  ? viewUser.nfp_info.picture
                  : defaultNfpImage
                : defaultNfpImage
                ? defaultNfpImage
                : defaultNfpImage)
                  ? ''
                  : '#C997C5',
              }"
              :size="100"
              :src="viewUser.nfp_info ? (viewUser.nfp_info.picture ? viewUser.nfp_info.picture : defaultNfpImage) : defaultNfpImage ? defaultNfpImage : defaultNfpImage"
              class="text-capitalize"
            >
              {{ viewUser.nfp_info.nfp_name ? viewUser.nfp_info.nfp_name[0] : "NFP" }}
            </a-avatar>
            <div class="d-flex flex-row" :style="{ 'margin-top': '26px' }">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ 'margin-right': '8px' }">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.6458 0.648784C10.9757 0.238571 11.4736 0 11.9998 0C12.526 0 13.0239 0.238571 13.3537 0.648784L14.9657 2.65518C15.3367 3.11777 15.9179 3.35907 16.5072 3.29518L19.0659 3.01678C19.5905 2.95846 20.1132 3.14192 20.4865 3.51539C20.8598 3.88886 21.0431 4.41184 20.9848 4.93677L20.7066 7.49676C20.6427 8.08643 20.8839 8.66795 21.3462 9.03916L23.3516 10.652C23.7616 10.982 24 11.4801 24 12.0066C24 12.5331 23.7616 13.0312 23.3516 13.3613L21.3398 14.9666C20.8776 15.3384 20.6366 15.9201 20.7002 16.5101L20.9784 19.0701C21.0371 19.5951 20.8539 20.1183 20.4805 20.4919C20.1072 20.8655 19.5842 21.0488 19.0595 20.9901L16.5008 20.7117C15.9115 20.6476 15.3301 20.8889 14.9593 21.3517L13.3537 23.3506C13.0241 23.7612 12.5261 24 11.9998 24C11.4734 24 10.9755 23.7612 10.6458 23.3506L9.03497 21.3453C8.66351 20.8826 8.08199 20.6414 7.49234 20.7053L4.93371 20.9837C4.40886 21.0428 3.88565 20.8596 3.51218 20.4859C3.1387 20.1123 2.95562 19.5888 3.01474 19.0637L3.29299 16.5037C3.35682 15.9137 3.11569 15.3319 2.65333 14.9602L0.649074 13.3485C0.238717 13.0187 0 12.5205 0 11.9938C0 11.4672 0.238717 10.969 0.649074 10.6392L2.65333 9.02636C3.11584 8.65528 3.35705 8.07366 3.29299 7.48396L3.01474 4.92397C2.95604 4.39894 3.13926 3.8757 3.51263 3.50214C3.886 3.12857 4.40896 2.94524 4.93371 3.00398L7.49234 3.28238C8.08196 3.34604 8.66338 3.10482 9.03497 2.64238L10.6458 0.648784Z"
                  fill="#00C853"
                />
                <path
                  d="M16.5 9L12.0214 15.3893C11.8746 15.5985 11.6502 15.7293 11.4063 15.7477C11.1624 15.7662 10.923 15.6706 10.7501 15.4856L8.0625 12.6112"
                  stroke="white"
                  stroke-width="2.08333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <p :style="{ 'font-weight': '700', 'font-size': '16px', 'line-height': '24px', color: '#00C853' }">Verified and Claimed</p>
            </div>
          </div>
        </div>

        <div class="doc-info">
          <span class="m-0 mt-md-2 doc-name" v-if="viewUser">
            {{ viewUser.nfp_info.nfp_name || viewUser.display_name }}
          </span>
          <div class="tag-cont">
            <div class="physician-tag">
              <font-awesome-icon v-if="viewUser.role === 'nfp'" class="tag-icon-oran" :icon="['far', 'hand-holding-heart']" :style="{ color: '#f5a623' }" />
              <div>Non-For-Profit</div>
            </div>
            <div class="tags" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }">
              {{ viewUser.nfp_info ? viewUser.nfp_info.nfp_type_desc : "" }}
            </div>
          </div>
          <p :style="{ 'font-weight': '700', 'font-size': '14px', 'line-height': '21px', color: '#0F1734' }" v-if="viewUser.nfp_info.address" class="m-0 doc-loc text-truncate">
            <font-awesome-icon size="1x" :style="{ color: '#0F1734' }" :icon="['fal', 'map-marker-alt']" />
            {{ viewUser.nfp_info.address.city }},
            {{ viewUser.nfp_info.address.state }}
          </p>
          <p :style="{ color: '#777' }" v-if="viewUser.address && viewUser.address.city" class="m-0 doc-loc text-truncate">
            <font-awesome-icon size="1x" :style="{ color: '#0F1734' }" :icon="['fal', 'map-marker-alt']" />
            {{ viewUser.address.city }}, {{ viewUser.address.state }}
          </p>
          <div class="d-flex justify-content-center">
            <div class="d-flex flex-row info-phy claim-card" :style="{ 'margin-top': '48px', padding: '24px 8px', width: '335px', height: '92px', border: 'none' }">
              <div class="d-flex flex-column" :style="{ 'margin-right': '31px', 'text-align': 'center', 'padding-left': '30px' }">
                <p class="prof-details-value">
                  {{ viewUser.recommendation_count || 0 }}
                </p>
                <p class="prof-details-title">Recommendations</p>
              </div>
            </div>
          </div>

          <!-- <div class="d-flex justify-content-center">
            <div class="d-flex flex-row info-phy claim-card" :style="{ 'margin-top': '16px', padding: '24px 8px', width: '335px', height: '92px', border: 'none' }">
              <div class="d-flex flex-column" :style="{ 'margin-right': '45px', 'text-align': 'center', 'padding-left': '30px', border: 'none' }">
                <p class="prof-details-value">{{ viewUser.no_of_members || 0 }}</p>
                <p class="prof-details-title">Circle Members</p>
              </div>
              <div class="divider" :style="{ background: '#CBD5E1', border: '1px solid #CBD5E1', height: '36px' }"></div>
              <div class="d-flex flex-column review-padding" :style="{ 'text-align': 'center' }">
                <p class="prof-details-value">{{ viewUser.no_of_circle_on || 0 }}</p>
                <p class="prof-details-title">Circle On</p>
              </div>
            </div>
          </div> -->
        </div>

        <div class="circle-card-footer">
          <div class="w-100 text-center d-flex justify-content-center">
            <div class="btns" :style="{ marginTop: '40px' }">
              <div class="d-flex flex-column w-100 gap16">
                <button v-if="!isDirectory" class="cp font-white primary-button review-btns" :style="{ background: getPrimaryColor() }" @click="() => $refs.MessageUserModal.ShowModal(viewUser)">
                  Message
                </button>
                <button
                  class="font-white primary-button review-btns d-flex w-100"
                  :style="{
                    background: this.DocRecommend ? getSecondaryColor() : getPrimaryColor(),
                    cursor: this.DocRecommend ? 'default' : 'pointer',
                    'flex-direction': 'row',
                    'justify-content': 'center',
                  }"
                  :disabled="this.DocRecommend"
                  @click="handleRecomendPhysician"
                >
                  <i class="fa fa-check" aria-hidden="true" v-if="this.DocRecommend" :style="{ ' margin-left': '-7px', 'padding-top': '4px', 'padding-right': ' 6px' }" />
                  {{ this.DocRecommend ? "Recommended" : "Recommend" }}
                </button>
                <a-button
                  :loading="loadingbtn"
                  class="font-white primary-button mt-3 circle-btn"
                  :style="{ background: viewUser.on_circle ? getSecondaryColor() : getPrimaryColor(), 'pointer-events': viewUser.on_circle ? 'none' : 'all' }"
                  @click="!viewUser.on_circle && addToCircle()"
                >
                  {{ viewUser.on_circle ? "In your circle" : "Add To Circle" }}
                </a-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="m-prof-sub">
        <ul class="sub-nav text-center">
          <li
            :style="
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates`
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            id="updates"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates` ? 'active-tabs' : 'tabs'"
            @click="handletab($event)"
          >
            Updates
          </li>
          <li
            :style="
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about`
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            id="about"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about` ? 'active-tabs' : 'tabs'"
            @click="handletab($event)"
          >
            About
          </li>
        </ul>
      </div>

      <!-- Web view -->
      <div class="dovemed-wrapper m-prof-wrapper py-4 padding-fix">
        <div class="row">
          <div class="col-md-4 col-lg-4 d-prof-progress">
            <div class="d-flex phy-profile-card-container">
              <button class="threedot-menu" :style="{ background: '#fff', border: 'none', display: 'flex', 'align-self': 'flex-end' }" @click="showOptions">
                <font-awesome-icon size="1x" :style="{ color: '#94A3B8' }" :icon="['fas', 'ellipsis-v']" />
                <div
                  v-if="displayDots"
                  :style="{ display: 'flex', 'flex-direction': 'column', 'align-self': 'flex-end', 'z-index': '1' }"
                  :class="`${displayDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`"
                >
                  <!-- menu-content shadow-card -->
                  <p class="card-item" @click="saveToDirectory">
                    <font-awesome-icon :icon="[`${viewUser.saved ? 'fas' : 'fal'}`, 'bookmark']" class="mr-2" />
                    {{ viewUser.saved ? "Saved to DoveDirectory" : "Save to DoveDirectory" }}
                  </p>
                  <p
                    class="card-item"
                    @click="
                      () => {
                        $refs.ShareProfileModal.showModal()
                      }
                    "
                  >
                    <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                      <path
                        d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
                        fill="black"
                      />
                    </svg>
                    Share Profile
                  </p>
                  <p class="divider"></p>
                  <p
                    class="card-item"
                    @click="
                      () => {
                        $refs.reportContentModal.show({ id: this.viewUser.id }, 15, 'nfp_administrator')
                      }
                    "
                  >
                    <font-awesome-icon size="1x" :icon="['fal', 'flag']" class="mr-2" />
                    Report
                  </p>
                </div>
              </button>
              <div class="profile-image mr-3 position-relative">
                <a-avatar
                  :style="{
                    color: ' #ffffff !important',
                    'background-color': (viewUser.nfp_info
                    ? viewUser.nfp_info.picture
                      ? viewUser.nfp_info.picture
                      : defaultNfpImage
                    : defaultNfpImage
                    ? defaultNfpImage
                    : defaultNfpImage)
                      ? ''
                      : '#C997C5',
                  }"
                  :size="150"
                  :src="viewUser.nfp_info ? (viewUser.nfp_info.picture ? viewUser.nfp_info.picture : defaultNfpImage) : defaultNfpImage ? defaultNfpImage : defaultNfpImage"
                  class="text-capitalize"
                >
                  {{ viewUser.nfp_info.nfp_name ? viewUser.nfp_info.nfp_name[0] : "NFP" }}
                </a-avatar>
              </div>
              <div class="d-flex flex-row" :style="{ 'margin-top': '26px' }">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ 'margin-right': '8px' }">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.6458 0.648784C10.9757 0.238571 11.4736 0 11.9998 0C12.526 0 13.0239 0.238571 13.3537 0.648784L14.9657 2.65518C15.3367 3.11777 15.9179 3.35907 16.5072 3.29518L19.0659 3.01678C19.5905 2.95846 20.1132 3.14192 20.4865 3.51539C20.8598 3.88886 21.0431 4.41184 20.9848 4.93677L20.7066 7.49676C20.6427 8.08643 20.8839 8.66795 21.3462 9.03916L23.3516 10.652C23.7616 10.982 24 11.4801 24 12.0066C24 12.5331 23.7616 13.0312 23.3516 13.3613L21.3398 14.9666C20.8776 15.3384 20.6366 15.9201 20.7002 16.5101L20.9784 19.0701C21.0371 19.5951 20.8539 20.1183 20.4805 20.4919C20.1072 20.8655 19.5842 21.0488 19.0595 20.9901L16.5008 20.7117C15.9115 20.6476 15.3301 20.8889 14.9593 21.3517L13.3537 23.3506C13.0241 23.7612 12.5261 24 11.9998 24C11.4734 24 10.9755 23.7612 10.6458 23.3506L9.03497 21.3453C8.66351 20.8826 8.08199 20.6414 7.49234 20.7053L4.93371 20.9837C4.40886 21.0428 3.88565 20.8596 3.51218 20.4859C3.1387 20.1123 2.95562 19.5888 3.01474 19.0637L3.29299 16.5037C3.35682 15.9137 3.11569 15.3319 2.65333 14.9602L0.649074 13.3485C0.238717 13.0187 0 12.5205 0 11.9938C0 11.4672 0.238717 10.969 0.649074 10.6392L2.65333 9.02636C3.11584 8.65528 3.35705 8.07366 3.29299 7.48396L3.01474 4.92397C2.95604 4.39894 3.13926 3.8757 3.51263 3.50214C3.886 3.12857 4.40896 2.94524 4.93371 3.00398L7.49234 3.28238C8.08196 3.34604 8.66338 3.10482 9.03497 2.64238L10.6458 0.648784Z"
                    fill="#00C853"
                  />
                  <path
                    d="M16.5 9L12.0214 15.3893C11.8746 15.5985 11.6502 15.7293 11.4063 15.7477C11.1624 15.7662 10.923 15.6706 10.7501 15.4856L8.0625 12.6112"
                    stroke="white"
                    stroke-width="2.08333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p :style="{ 'font-weight': '700', 'font-size': '16px', 'line-height': '24px', color: '#00C853' }">Verified and Claimed</p>
              </div>

              <div class="doc-info">
                <p class="m-0 doc-name text-capitalize" v-if="viewUser">
                  {{ viewUser.nfp_info ? viewUser.nfp_info.nfp_name : viewUser.display_name }}
                </p>
                <div class="tag-cont">
                  <div class="physician-tag">
                    <font-awesome-icon v-if="viewUser.role === 'nfp'" class="tag-icon-oran" :icon="['far', 'hand-holding-heart']" :style="{ color: '#f5a623' }" />
                    <div>Non-For-Profit</div>
                  </div>
                  <div class="tags" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }">
                    {{ viewUser.nfp_info ? viewUser.nfp_info.nfp_type_desc : "" }}
                  </div>
                </div>
                <p :style="{ color: '#0F1734', 'font-weight': '700', 'font-size': '14px', 'line-height': '21px', 'padding-bottom': '14.5px' }" v-if="viewUser" class="m-0 doc-loc text-truncate">
                  <!-- <i class="fa fa-map-marker" aria-hidden="true"></i> -->
                  <font-awesome-icon size="1x" :style="{ color: '#0F1734' }" :icon="['fal', 'map-marker-alt']" />
                  {{ viewUser.nfp_info ? viewUser.nfp_info.address.city : viewUser.location[0].city }},
                  {{ viewUser.nfp_info ? viewUser.nfp_info.address.state : viewUser.location[0].state }}
                </p>
                <p :style="{ color: '#777' }" v-if="viewUser.address && viewUser.address.city" class="m-0 doc-loc text-truncate">
                  <!-- <i class="fa fa-map-marker" aria-hidden="true"></i> -->
                  <font-awesome-icon size="1x" :style="{ color: '#0F1734' }" :icon="['fal', 'map-marker-alt']" />

                  {{ viewUser.address.city }},
                  {{ viewUser.address.state }}
                </p>

                <!-- ==========================circle box====================================== -->
                <div>
                  <div class="d-flex flex-row info-phy claim-card" :style="{ 'margin-top': '48px', padding: '24px 8px', width: '335px', height: '92px', border: 'none' }">
                    <div class="d-flex flex-column" :style="{ 'margin-right': '31px', 'text-align': 'center', 'padding-left': '30px' }">
                      <p class="prof-details-value">{{ viewUser.recommendation_count || 0 }}</p>
                      <p class="prof-details-title">Recommendations</p>
                    </div>
                  </div>
                </div>
                <!-- <div>
                  <div class="d-flex flex-row info-phy claim-card" :style="{ 'margin-top': '16px', padding: '24px 8px', 'justify-content': 'space-evenly' }">
                    <div class="d-flex flex-column">
                      <p class="prof-details-value">{{ viewUser.no_of_members || 0 }}</p>
                      <p class="prof-details-title">Circle Members</p>
                    </div>
                    <div class="divider" :style="{ background: '#CBD5E1', border: '1px solid #CBD5E1', height: '36px' }"></div>
                    <div class="d-flex flex-column">
                      <p class="prof-details-value">{{ viewUser.no_of_circle_on || 0 }}</p>
                      <p class="prof-details-title">Circle On</p>
                    </div>
                  </div>
                </div> -->
              </div>

              <div class="btns d-flex flex-row w-100 gap16" :style="{ marginTop: '40px' }">
                <button v-if="!isDirectory" class="cp font-white primary-button review-btns" :style="{ background: getPrimaryColor() }" @click="() => $refs.MessageUserModal.ShowModal(viewUser)">
                  Message
                </button>
                <button
                  class="w-100 font-white primary-button review-btns d-flex"
                  :style="{
                    background: this.DocRecommend ? getSecondaryColor() : getPrimaryColor(),
                    cursor: this.DocRecommend ? 'default' : 'pointer',
                    'flex-direction': 'row',
                    'justify-content': 'center',
                  }"
                  :disabled="this.DocRecommend"
                  @click="handleRecomendPhysician"
                >
                  <i class="fa fa-check" aria-hidden="true" v-if="this.DocRecommend" :style="{ ' margin-left': '-7px', 'padding-top': '4px', 'padding-right': ' 6px' }" />
                  {{ this.DocRecommend ? "Recommended" : "Recommend" }}
                </button>
              </div>
              <a-button
                :loading="loadingbtn"
                class="font-white primary-button mt-3 circle-btn"
                :style="{ background: viewUser.on_circle ? getSecondaryColor() : getPrimaryColor(), 'pointer-events': viewUser.on_circle ? 'none' : 'all' }"
                @click="!viewUser.on_circle && addToCircle()"
              >
                {{ viewUser.on_circle ? "In your circle" : "Add To Circle" }}
              </a-button>
            </div>
          </div>
        </div>

        <div class="col-md-8 col-lg-8 col-sm-12 col-xs-12 about-phy">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <!-- <RecommendDoctorModal ref="RecommendDoctorModal" :fetchUser="fetchDocData" /> -->
    <!-- <RecommendOthersModal ref="recommendOthersModal" :fetchUser="fetchDocData" /> -->
    <AddToCircle ref="AddToCircle" />
    <ShareProfileModal ref="ShareProfileModal" />
    <ReportContentModal ref="reportContentModal" />
    <MessageUserModal ref="MessageUserModal" />
    <DrawerModal ref="drawerShareRef">
      <div @click="() => $refs.drawerShareRef.close()">
        <p class="drawer-item" @click="saveToDirectory">
          <font-awesome-icon :icon="[`${viewUser.saved ? 'fas' : 'fal'}`, 'bookmark']" class="mr-2" />
          {{ viewUser.saved ? "Saved to DoveDirectory" : "Save to DoveDirectory" }}
        </p>
        <p
          class="drawer-item"
          @click="
            () => {
              $refs.ShareProfileModal.showModal()
            }
          "
        >
          <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
            <path
              d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
              fill="black"
            />
          </svg>Share Profile
        </p>
        <p
          class="drawer-item"
          @click="
            () => {
              $refs.reportContentModal.show({ id: this.viewUser.id }, 15, 'nfp_administrator')
            }
          "
        >
          <font-awesome-icon size="1x" :icon="['fal', 'flag']" class="mr-2" />
          Report
        </p>
      </div>
    </DrawerModal>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import ReportContentModal from "../../../Modals/ReportContent.vue"
// import RecommendDoctorModal from "../../../Modals/RecommendDoctor"
// import RecommendOthersModal from "../../../Modals/RecommendOthers"
import ReviewStar from "../../Doctor/reviewStar.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faMapMarkerAlt } from "@fortawesome/pro-light-svg-icons"
import ShareProfileModal from "../../../Modals/ShareProfileModal.vue"
import AddToCircle from "../../../Modals/AddToCircle.vue"
import MessageUserModal from "../../../Modals/MessageUserModal"
import DrawerModal from "../../../Modals/DrawerModal.vue"

library.add(faMapMarkerAlt)
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "ViewNfpProfile",
  components: {
    // RecommendDoctorModal,
    AddToCircle,
    ReviewStar,
    ShareProfileModal,
    MessageUserModal,
    // RecommendOthersModal,
    ReportContentModal,
    DrawerModal,
  },
  data() {
    return {
      selectedTab: "Reviews & More",
      displayDots: false,
      displayDots2: false,
      DocRecommend: false,
      defaultNfpImage: " https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/nfp-icon.svg",
      loading: true,
    }
  },

  created() {
    this.fetchDocData().then(() => {
      this.DocRecommend = this.viewUser.recommend
      console.warn("ViewNfpProfile.vue is created")
      console.log("viewUser:", this.viewUser)
      this.loading = false
    })
  },

  methods: {
    saveToDirectory() {
      if (this.viewUser.saved) {
        return
      }
      let payload = {
        owner_user: this.authUser.user.id,
        owner_user_role: this.authUser.user.role,
        saved_user: this.viewUser.ext_ref_id ? this.viewUser.ext_ref_id : this.viewUser.id,
        saved_user_role: "nfp_administrator",
        circle_id: this.currentCircle.id,
      }
      UserRepository.SaveToDirectory(payload)
        .then(res => {
          this.$notification.success({ message: "Saved", description: `Profile saved to directory successfully` })
          this.viewUser.saved = true
        })
        .catch(err => {
          this.$notification.error({ message: "Error", description: `Profile was not saved to directory` })
        })
    },

    // handlereview(viewUser) {
    //   if (!viewUser.recommend) {
    //     this.$refs.recommendOthersModal.show({ ...viewUser, role: "nfp_administrator", page: 0 })
    //   }
    // },

    handleRecomendPhysician() {
      const payload = {
        type: "recommended",
        reviewer_id: this.authUser.user.id,
        reviewer_role: this.authUser.user.role,
        reviewee_id: this.viewUser.ext_ref_id,
        reviewee_role: "nfp_administrator",
        circle_id: this.currentCircle.id,
        recommended: "true",
      }
      UserRepository.recommendPhysician(payload)
        .then(res => {
          this.$notification.success({ message: "Success", description: "Recommended this NFP successfully" })
          this.DocRecommend = true
          this.$store.commit("User/setToggleReview")
          // this.fetchDocData()
          this.viewUser.recommendation_count += 1
        })
        .catch(err => {})
    },

    async fetchDocData() {
      const data = await UserRepository.getOtherEntityProfile({ id: this.$route.params.id, role: "nfp_administrator" }, this.currentCircle.id)
      console.log("fetchDocData() -> data:", data.data.data)
      this.viewUser.recommend = true
      this.$store.commit("User/setViewUser", { data: { ...data.data.data, role: "nfp", isDirectory: true } })

      const res = await UserRepository.getIndividualRecommend(this.currentCircle.id, 1, 1, this.viewUser.id, "Newest")
      console.log("res.data.data:", res.data.data)
    },

    showOptions() {
      this.displayDots = !this.displayDots
    },

    handletab(event) {
      switch (event.target.id) {
        case "updates":
          this.selectedTab = "Reviews & More"
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/updates` })
          break
        case "dovedaily":
          this.selectedTab = "Reviews & More"
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/dovedaily` })
          break
        case "about":
          this.selectedTab = "Reviews & More"
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/about` })
          break
        case "circles":
          this.selectedTab = "Reviews & More"
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/circles/ViewAllCircle` })
          break
        case "qa":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/qa` })
          break
        case "polls":
          this.$router.push({ name: "ViewDoctorProfilePolls" })
          break
        case "saved":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/saved` })
          break
        case "reviews":
          this.$router.push({ name: "ViewDoctorProfileReviews", params: { ext_ref_id: this.viewUser.id, circle_id: this.currentCircle.id } })
          break
        default:
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/updates` })
          break
      }
    },

    addToCircle() {
      UserRepository.addUserByTypeToCircle(this.viewUser.ext_ref_id, this.currentCircle.id, this.viewUser.role)
        .then(res => {
          this.$notification.success({ message: "Success", description: res.data.message })
          this.$store.commit("User/setViewUser", { data: { ...this.viewUser, on_circle: true } })
        })
        .catch(err => {
          this.$notification.info({ message: "Information", description: err.response.data.message })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.claim-card {
  border: none !important;
}

.tag-icon-oran {
  height: 17.5px;
  width: 20px;
  color: #f5a623;
}

.physician-tag {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  background: #fff0d6;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  color: #f5a623;
  text-transform: capitalize;
}

.tags {
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  margin-right: 5px;
  border-radius: 4px;
  text-transform: capitalize;
}

.tag-cont {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 17.5px;
  margin-top: 16px;
}

.tabe {
  display: flex;
  gap: 5px;
  align-items: center;
}

.review-padding {
  padding-left: 70px;
}

.padding-fix {
  margin-top: 10px;
  padding-top: 0px;
}

@media screen and (max-width: 426px) {
  .review-padding {
    padding-left: 50px !important;
  }
  /* Hide scrollbar for Chrome, Safari and Opera */
  .m-prof-sub ::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  .m-prof-sub {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none;
  }
  .m-prof {
    box-shadow: none !important;
    background: none !important;
  }
  .m-prof .circle-card-content {
    margin-top: 0rem !important;
  }
}
.info-phy {
  display: flex !important;
  align-items: center;
  justify-content: center;
  p {
    margin-bottom: 0px;
  }

  .prof-details-title {
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #94a3b8;
  }

  .prof-details-value {
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #0f1734;
  }
}
.about-phy {
  margin-top: 60px;
  margin-left: 420px;
  margin-right: 10px;
}
.prof-details-title {
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #94a3b8;
}
.profile-tabs {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  position: absolute;
  margin-left: 17px;
}

.active-tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
}

.review-btns {
  padding: 12px 24px;
  width: 100%;
  height: 48px;
  border-radius: 6px;
  border: none;
}

.tags {
  padding: 4px 8px;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  margin-right: 5px;
  border-radius: 4px;
}

.tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  // color: #0F1734;
}

.circle-btn {
  padding: 12px 24px;
  width: 335px;
  height: 48px;
  border-radius: 6px;
  border: none;
}
.phy-profile-card-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  position: absolute;
  width: 383px;
  height: 937px;
  background: #ffffff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: -220px;
}
.banner {
  // min-height: 250px;
  // max-height: 400px;
  height: 400px;

  img {
    min-height: 250px;
    max-height: 400px;
    width: 100%;
    object-fit: cover;
  }
}

.profile-subnav {
  background: #fff;
}

.profile-image {
  min-width: 150px;
  height: 150px;
  align-self: center;
  border-radius: 50%;
}
.mob {
  @media screen and (max-width: 900px) {
    position: relative;
    top: 140px;
    left: 301px;
    z-index: 10;
  }
}

.option-mob {
  @media screen and (max-width: 900px) {
    width: max-content;
  }
}
.doc-info {
  .doc-name {
    font-weight: 700;
    font-size: 36px;
    line-height: 46px;
    color: #0f1734;
    white-space: inherit;
  }

  .doc-loc text-truncate,
  .recommendations {
    font-size: 16px;
  }
}

ul.sub-nav {
  list-style-type: none;
  padding: 0;
  display: flex;

  li {
    display: inline-block;
    margin-right: 20px;
  }
}

.shadow-card {
  .p {
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;
    color: #1e2945;
  }
}

.nav-sec {
  position: relative;
  width: 66%;
  margin-left: 365px;
  text-align: right;

  .sub-nav {
    position: absolute;
    width: 100%;
    bottom: 0;
  }
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  .title {
    font-size: 18px;
    font-weight: bold;
  }

  .sub-title {
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    color: #0f1734;
  }
}

.ad-container {
  background: #b6d28a;
  width: 100%;
  height: 400px;
}
.rating-box {
  position: absolute;
  left: 50%;
  bottom: -10px;
  transform: translateX(-50%);
  padding: 5px 8px;
  display: flex;
  align-items: center;
  color: #fff;
  border-radius: 15px;
  .star-rating {
    margin-right: 5px;
  }
  span {
    color: #fff;
  }
}
@media screen and (max-width: 900px) {
  .doc-info {
    text-align: left;
    margin-top: 10px;
    flex-direction: column;
    display: flex;
  }
  .about-phy {
    margin-left: 10px;
  }
  .rating-box {
    position: absolute;
    left: 50%;
    bottom: -16px;
    transform: translateX(-50%);
    padding: 5px 8px;
    display: flex;
    align-items: center;
    color: #fff;
    border-radius: 15px;
    .star-rating {
      margin-right: 5px;
    }
    span {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/view/ViewNfpProfile.vue